import KunLoading90 from './src/index'

KunLoading90.install = function (Vue) {
	Vue.component(KunLoading90.name, KunLoading90);
}

export default KunLoading90;
